import $store from "@/store";

window.addEventListener("beforeunload", (event: BeforeUnloadEvent) => {
  // Prevent if there is any active downloads
  if ($store.getters["downloads/activeDownloads"].length > 0) {
    event.preventDefault();
    event.returnValue = "";
  }
});

window.addEventListener("beforeunload", (event: BeforeUnloadEvent) => {
  if ($store.state.application.preventReload) {
    event.preventDefault();
    event.returnValue = "";
  }
});
